import { render, staticRenderFns } from "./SocialId.vue?vue&type=template&id=27bfa88e&"
import script from "./SocialId.vue?vue&type=script&lang=js&"
export * from "./SocialId.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports